var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wscn-http404-container" }, [
    _c("div", { staticClass: "wscn-http404" }, [
      _c("div", { staticClass: "bullshit" }, [
        _c("img", {
          staticClass: "pic-404__parent",
          attrs: { src: require("@/assets/404_images/404-01.png"), alt: "404" },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "bullshit__headline text-center" }, [
          _vm._v(_vm._s(_vm.message)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bullshit__info text-center" }, [
          _vm._v("您可能输错了网址，或该网页已被删除、不存在等"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-center mt14" },
          [
            _c(
              "router-link",
              { attrs: { to: { path: _vm.roterPre + "/user/work" } } },
              [
                _c("span", { staticClass: "bullshit__return-home" }, [
                  _vm._v("返回首页"),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }